import React from 'react';
import BordereauStateFactory from '../../../classes/bordereaux/state/BordereauStateFactory';
import type BordereauStateType from '../../../constants/liquidation/bordereaux/BordereauStateType';
import TreeViewType from '../../../constants/liquidation/TreeViewType';
import type SensOptions from '../../../interfaces/pieces/bordereaux/SensOptions';
import LiquidationTreeview from './LiquidationTreeview';
import FiltersTreeview from './Mouvement/FiltersTreeview';
import './LiquidationContainer.css';
import { useWindowDimensions } from '@mairistem/finances-utils';

const LiquidationContainer = () => {
	const [selectedAnnee, setSelectedAnnee] = React.useState<number | null>(
		undefined,
	);
	const [selectedSens, setSelectedSens] = React.useState<SensOptions>('T');
	const [selectedBordereauState, setSelectedBordereauState] = React.useState<
		number | null
	>(null);

	const [visibleStates, setVisibleStates] = React.useState<
		Set<BordereauStateType>
	>(new Set());

	const { height } = useWindowDimensions();

	const handleAnneeChange = (anneeExercice: number): void => {
		setSelectedAnnee(anneeExercice);
	};

	const handleSensChange = (sens: SensOptions): void => {
		setSelectedSens(sens);
	};

	const handleFiltreBordereauChange = (bordereauState: number): void => {
		setSelectedBordereauState(bordereauState);
	};

	React.useEffect(() => {
		if (selectedBordereauState === null) return;

		const selectedState = BordereauStateFactory.getAllStates().find(
			(state) => state.step === selectedBordereauState,
		);

		if (!selectedState || !visibleStates.has(selectedState.state)) {
			setSelectedBordereauState(null);
		}
	}, [visibleStates, selectedBordereauState]);

	return (
		<div className="liquidation-container">
			<FiltersTreeview
				onAnneeChange={handleAnneeChange}
				onSensChange={handleSensChange}
				selectedAnnee={selectedAnnee}
				onFiltreBordereauChange={handleFiltreBordereauChange}
				visibleStates={visibleStates}
			/>
			{selectedAnnee && (
				<LiquidationTreeview
					type={TreeViewType.MOUVEMENT}
					height={height}
					anneeExercice={selectedAnnee}
					filterSens={selectedSens}
					filtreBordereauState={selectedBordereauState}
					onVisibleStatesChange={setVisibleStates}
				/>
			)}
		</div>
	);
};

export default LiquidationContainer;
